<template>
  <div class="infoModalContainer">
    <div class="header">
      <p class="title">{{ $t('coinPusherRulesGameName') }}</p>
      <img class="close" src="/img/icons/bone_close.svg" alt="close" @click="getOut" />
    </div>
    <div class="body">
      <div class="section">
        <h3 v-html="$t('coinPusherRulesHeader1')"></h3>
        <ul>
          <li
            v-html="
              $t('coinPusherRulesRow1', {
                amountToken: betSize ?? $t('coinPusherRulesRow1VariousAmount'),
                amountBet: MAX_BETS,
                tokenName: tokensConfig[token!]?.name?.contract?.toUpperCase()
              })
            "
          />
          <li v-html="$t('coinPusherRulesRow2')" />
          <li v-html="$t('coinPusherRulesRow3')" />
          <li v-html="$t('coinPusherRulesRow4')" />
        </ul>
        <hr class="custom-hr" />
      </div>
      <div class="section">
        <h3 v-html="$t('coinPusherRulesHeader2')"></h3>
        <ul>
          <li v-html="$t('coinPusherRulesRow5')" />
        </ul>
        <hr class="custom-hr" />
      </div>
      <div class="section">
        <h3 v-html="$t('coinPusherRulesHeader3')"></h3>
        <ul>
          <li v-html="$t('coinPusherRulesRow6')" />
        </ul>
        <hr class="custom-hr" />
      </div>

      <div class="section">
        <h3 v-html="$t('coinPusherRulesHeader4')"></h3>
        <ul>
          <li v-html="$t('coinPusherRulesRow7')" />
          <li v-html="$t('coinPusherRulesRow8')" />
          <li v-html="$t('coinPusherRulesRow9')" />
          <li v-html="$t('coinPusherRulesRow10')" />
          <li v-html="$t('coinPusherRulesRow11')" />
        </ul>
        <hr class="custom-hr" />
      </div>

      <div class="section">
        <h3 v-html="$t('coinPusherRulesHeader5')"></h3>
        <ul>
          <li v-html="$t('coinPusherRulesRow12')" />
          <li v-html="$t('coinPusherRulesRow13')" />
        </ul>
        <hr class="custom-hr" />
      </div>
      <h3>{{ $t('coinPusherRulesFooter') }}</h3>
    </div>
  </div>
</template>

<script setup lang="ts">
import { tokensConfig, Tokens } from '~/utils/constants';

const emit = defineEmits(['go-to-stats', 'get-out']);
const token = defineModel<Tokens>('token');

const getOut = () => {
  emit('get-out');
};

const MAX_BETS = 20;
const betSize = inject('pusherBetSize');
</script>

<style lang="scss" scoped>
.infoModalContainer {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  margin: 0 auto;
  z-index: 9999;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 20px;

  .title {
    font-size: 20px;
    line-height: 20px;
    font-weight: 700;
    color: #fff;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 80%;
    margin: 0 auto;
  }

  .close {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
}

.body {
  text-align: center;
  font-size: 20px;
  color: #fff;
  max-height: 400px;
  overflow-y: scroll;

  h3 {
    font-size: 18px;
    font-weight: 700;
  }

  .section {
    padding-top: 20px;

    ul {
      list-style: none;
      font-size: 16px;
      font-weight: 400;
      line-height: 26px;
      position: relative;
      text-align: center;
      padding: 0px 30px;

      li {
        margin-bottom: 0.5em;

        ::v-deep(span) {
          color: #88e1ff;
        }

        &::before {
          content: '• ';
          font-size: 0.9em;
          margin-right: 6px;
        }
      }
    }

    hr.custom-hr {
      border: none;
      height: 1px;
      background: linear-gradient(to right, transparent, rgba(255, 223, 128, 0.2), transparent);
      margin: 20px auto;
      width: 60%;
    }
  }
}
</style>
